/**
 * Created by asiulik on 21.12.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', '../../utils'], function($, _, EventEmitter, Utils){

    var loadmoreConfig = {
        containerSelector: ".m__loadmore",
        itemsSelector: '.loadmore__element',
        activeClass: "loadmore__element--active",
        buttonSelector: ".loadmore__button",
        visibilityStep: 10
    };

    function ContentLoadMore(){}

    ContentLoadMore.prototype = _.clone(EventEmitter.prototype);

    ContentLoadMore.prototype.init = function(){

        var _this = this;
        var $containers = $(loadmoreConfig.containerSelector);
        if(!$containers.length) return;

        $containers.each(function(index, loadMoreContainer){
            _this.initLoadMore(loadMoreContainer);
        });

        this.bindEvents();

    };

    ContentLoadMore.prototype.bindEvents = function(){

        this.on('content:loadmore:allDisplayed', function($container) {
            $container.find(loadmoreConfig.buttonSelector).remove();
        });

    };

    ContentLoadMore.prototype.initLoadMore = function(container){

        var _this = this;
        var $container = $(container);
        var $items = $container.find(loadmoreConfig.itemsSelector);
        var $loadMoreButton = $container.find(loadmoreConfig.buttonSelector);

        $loadMoreButton.on({
            click: function(){
                _this.showMoreContent($container, $items);
            }
        })

    };

    ContentLoadMore.prototype.showMoreContent = function($container, $items){

        var stepVal = $container.find(loadmoreConfig.buttonSelector).data('contentMore') || loadmoreConfig.visibilityStep;
        // console.log('load more config step value', stepVal);

        var currentVisible = this.getDisplayElementsCount($items, loadmoreConfig.activeClass);
        var nextVisible = currentVisible + stepVal;

        // console.log('nextVisible', nextVisible);

        var $lastElement = $items.eq(currentVisible - 1);

        var scrollToElement = $lastElement.offset().top + $lastElement.height() - 100;

        var elementsShouldBeVisible = $items.slice(0, nextVisible);
        elementsShouldBeVisible.addClass(loadmoreConfig.activeClass);

        this.emit('content:loadmore:show');

        if(nextVisible >= $items.length) {
            this.emit('content:loadmore:allDisplayed', $container);
        }

        setTimeout(function(){
            Utils.scrollPositionAnimate(scrollToElement);
        }, 200);

    };

    ContentLoadMore.prototype.getDisplayElementsCount = function(collection, className){
        return collection.filter(function(index, item){
            return $(item).hasClass(className)
        }).length
    };

    return ContentLoadMore;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/content/contentLoadmore.js